import * as React from "react"

import Layout from "../../../components/layout"
import Seo from "../../../components/seo"
import PageTitle from "../../../components/sections/page-title/page-title"
import MembersList from "../../../components/members-cards/members"

import { Link, graphql, useStaticQuery } from "gatsby"

const CARESMembers = () => {
  const { allContentfulCommittee } = useStaticQuery(graphql`
    {
      allContentfulCommittee(filter: { title: { eq: "CARES" } }) {
        nodes {
          members {
            name
            photo {
              file {
                url
              }
            }
            role
          }
          title
        }
      }
    }
  `)

  return (
    <Layout>
      <PageTitle
        title={`CARES Members`}
        description={``}
        crumbs={[
          { title: `Home`, link: `/` },
          { title: `About`, link: `/about` },
          { title: `CARES`, link: `/about/sigchi-cares` },
          { title: `Members`, link: `` },
        ]}
      />
      <section>
        <div className={`content`}>
          <MembersList list={allContentfulCommittee.nodes[0].members} />
        </div>
      </section>
    </Layout>
  )
}

export const Head = () => <Seo title="CARES Members" />

export default CARESMembers
